// 本地存储前缀
const LOCAL_STORAGE_PREFIX = 'bjx_crm_'

/**
 * 设置本地存储数据
 * @param key 存储的 key
 * @param data 存储的数据
 * @param isJson 是否转换为字符串
 * @param prefix 存储前缀
 */
const setStorage = (key, data, isJson = true, prefix = LOCAL_STORAGE_PREFIX) => {
    if (isJson) {
        data = JSON.stringify(data)
    }
    return localStorage.setItem(prefix+key, data)
}

/**
 * 获取本地存储数据
 * @param key 存储的 key
 * @param defaultValue 默认值
 * @param isJson 是否转换为字符串
 * @param prefix 存储前缀
 * @returns {string}
 */
const getStorage = (key, defaultValue= null, isJson= true, prefix = LOCAL_STORAGE_PREFIX) => {
    let data = localStorage.getItem(prefix+key)
    data = data === null ? defaultValue : data
    if (isJson) {
        data = JSON.parse(data)
    }
    return data
}

/**
 * 清除本地 token
 * @param key
 * @param prefix
 */
const removeStorage = (key, prefix = LOCAL_STORAGE_PREFIX) => {
    return localStorage.removeItem(prefix+key)
}

export {setStorage, getStorage, removeStorage}